/** Stable synthetic node ID for the Product Defaults group (all scopes). */
export const PRODUCT_DEFAULTS_GROUP_ID = "group:product_defaults";
